import './card.scss';

/**
 * version    1.0
 * class      <type> (Card)
 * classdesc  Component that manage card
 */
export class Card {
  constructor() {
    this.cardsAccordion = document.querySelectorAll('.cdp-card--abstract-overlay-accordion');
    this.cardsPanel = document.querySelectorAll('.cdp-card--side-panel');
    this.panels = document.querySelectorAll('.cdp-side-panel');

    this.init();
  }

  init() {
    this.initAccordion();
    this.initSidePanel();
    this.initPanelClose();
    this.initEsc();
  }

  // -------------------------
  // ACCORDION
  // -------------------------
  initAccordion() {
    if (!this.cardsAccordion.length) return;

    this.cardsAccordion.forEach((card) => {
      const toggle = card.querySelector('.cdp-card__toggle');
      if (!toggle) return;

      toggle.setAttribute('aria-expanded', 'false');

      toggle.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();

        const isOpen = card.classList.contains('is-open');

        this.closeAll();

        if (!isOpen) {
          this.open(card, toggle);
        }
      });
    });
  }

  open(card, toggle) {
    card.classList.add('is-open');
    toggle.setAttribute('aria-expanded', 'true');
  }

  close(card, toggle) {
    card.classList.remove('is-open');
    toggle.setAttribute('aria-expanded', 'false');
  }

  closeAll() {
    this.cardsAccordion.forEach((card) => {
      const toggle = card.querySelector('.cdp-card__toggle');
      if (!toggle) return;
      this.close(card, toggle);
    });
  }

  // -------------------------
  // SIDE PANEL
  // -------------------------
  initSidePanel() {
    if (!this.cardsPanel.length) return;

    this.cardsPanel.forEach((card) => {
      const trigger = card.querySelector('[data-side-panel-open]');
      if (!trigger) return;

      trigger.setAttribute('aria-expanded', 'false');

      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();

        const panelId = trigger.getAttribute('data-side-panel-open');
        const panel = document.getElementById(panelId);

        if (!panel) return;

        const isOpen = panel.classList.contains('cdp-side-panel--open');

        this.closeAllPanels();

        if (!isOpen) {
          this.openPanel(panel, trigger);
        }
      });
    });
  }

  openPanel(panel, trigger) {
    panel.classList.add('cdp-side-panel--open');
    trigger.setAttribute('aria-expanded', 'true');
  }

  closePanel(panel) {
    panel.classList.remove('cdp-side-panel--open');

    const trigger = document.querySelector(
      `[data-side-panel-open="${panel.id}"]`,
    );
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
  }

  closeAllPanels() {
    this.panels.forEach((panel) => this.closePanel(panel));
  }

  // -------------------------
  // CLOSE HANDLERS
  // -------------------------
  initPanelClose() {
    if (!this.panels.length) return;

    this.panels.forEach((panel) => {
      panel.querySelectorAll('[data-side-panel-close]').forEach((el) => {
        el.addEventListener('click', () => {
          this.closePanel(panel);
        });
      });
    });
  }

  initEsc() {
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        this.closeAllPanels();
      }
    });
  }
}
